module.exports = __webpack_public_path__ + "3a7fe87e36a289b6229ad0e088dce9a2.svg";